import { registerYoutubeVideosLoader } from './yt-videos-loader'

const itemsToEntry = [].slice.call(document.querySelectorAll('.entry'))

if ('IntersectionObserver' in window) {
  let entryRootMargin = ''
  const itemEntryObserver = new IntersectionObserver(
    function (entries, observer) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          const entryElement = entry.target
          let itemToEntry = entryElement
          entryRootMargin = entryElement.dataset.rootMargin
            ? `${entryElement.dataset.rootMargin} 0px`
            : '-50px 0px'

          if (itemToEntry.classList.contains('entry-delay')) {
            setTimeout(() => {
              itemToEntry.classList.remove('entry')
              itemToEntry.classList.add('entered')
              itemEntryObserver.unobserve(itemToEntry)
            }, 600)
          } else {
            setTimeout(() => {
              itemToEntry.classList.remove('entry')
              itemToEntry.classList.add('entered')
              itemEntryObserver.unobserve(itemToEntry)
            }, 200)
          }
        }
      })
    },
    { rootMargin: entryRootMargin }
  )

  itemsToEntry.forEach(function (itemToEntry) {
    itemEntryObserver.observe(itemToEntry)
  })
} else {
  itemsToEntry.forEach(function (itemToEntry) {
    itemToEntry.classList.remove('entry')
    itemToEntry.classList.add('entered')
  })
}

const lazyImages = [].slice.call(
  document.querySelectorAll('img.lazy, iframe.lazy')
)

if ('IntersectionObserver' in window) {
  const lazyImageObserver = new IntersectionObserver(
    function (entries, observer) {
      entries.forEach(function (entry) {
        let lazyImage = entry.target

        if (entry.isIntersecting && lazyImage.classList.contains('lazy')) {
          if (lazyImage.dataset.src) {
            lazyImage.src = lazyImage.dataset.src
          } else {
            lazyImage.srcset = lazyImage.dataset.srcset
          }
          lazyImageObserver.unobserve(lazyImage)
          lazyImage.classList.remove('lazy')
        }
      })
    },
    { rootMargin: '100px 0px' }
  )

  lazyImages.forEach(function (lazyImage) {
    lazyImageObserver.observe(lazyImage)
  })
} else {
  lazyImages.forEach(function (lazyImage) {
    if (lazyImage.dataset.src) {
      lazyImage.src = lazyImage.dataset.src
    } else if (lazySlideImg.dataset.srcset) {
      lazyImage.srcset = lazyImage.dataset.srcset
    }
  })
}

const lazyBgImages = [].slice.call(document.querySelectorAll('div[data-style]'))

if ('IntersectionObserver' in window) {
  const lazyBgImageObserver = new IntersectionObserver(
    function (entries, observer) {
      entries.forEach(function (entry) {
        let lazyBgImage = entry.target

        if (entry.isIntersecting && lazyBgImage.classList.contains('lazy')) {
          lazyBgImage.setAttribute('style', lazyBgImage.dataset.style)
          lazyBgImageObserver.unobserve(lazyBgImage)
          lazyBgImage.classList.remove('lazy')
        }
      })
    },
    { rootMargin: '300px 0px' }
  )

  lazyBgImages.forEach(function (lazyBgImage) {
    lazyBgImageObserver.observe(lazyBgImage)
  })
} else {
  lazyBgImages.forEach(function (lazyBgImage) {
    if (lazyBgImage.dataset.style) {
      lazyBgImage.setAttribute('style', lazyBgImage.dataset.poster)
    }
  })
}

const lazyVideos = [].slice.call(
  document.querySelectorAll('div[data-video-id]')
)

if ('IntersectionObserver' in window) {
  const lazyVideoObserver = new IntersectionObserver(
    function (entries, observer) {
      entries.forEach(function (entry) {
        let lazyVideo = entry.target

        if (entry.isIntersecting && lazyVideo.classList.contains('lazy')) {
          registerYoutubeVideosLoader()
          lazyVideoObserver.unobserve(lazyVideo)
          lazyVideo.classList.remove('lazy')
        }
      })
    },
    { rootMargin: '500px 500px' }
  )

  lazyVideos.forEach(function (lazyVideo) {
    lazyVideoObserver.observe(lazyVideo)
  })
} else {
  lazyVideos.forEach(function (lazyVideo) {
    if (lazyVideo.dataset.videoId) {
      registerYoutubeVideosLoader()
    }
  })
}
